<ng-container *ngIf="canModify">
  <app-instrument-settlement-consult [(canModify)]="canModify" [(canSave)]="canSave"> </app-instrument-settlement-consult>
</ng-container>
<ng-container *ngIf="canSave">
  <app-instrument-settlement-edit [(canModify)]="canModify" [(canSave)]="canSave"></app-instrument-settlement-edit>
</ng-container>
